import axios from '@axios'

const state = () => ({
  supplierTags: {
    meta: {
      pagination: {
        page: 1,
        per_page: 10,
        total_objects: 0,
      },
    },
    data: [],
  },
})

const getters = {
  supplierTags(state) {
    return state.supplierTags.data
  },
}

const mutations = {
  SET_SUPPLIER_TAGS(state, payload) {
    state.supplierTags = payload
  },
}

const actions = {
  fetchSupplierTags(
    context,
    params = {
      by_active_status: true,
    },
  ) {
    return new Promise((resolve, reject) => {
      axios
        .get('/v1/supplier_tags', {
          params: {
            ...params,
            meta: {
              pagination: {
                all: true,
              },
            },
          },
        })
        .then(response => {
          context.commit('SET_SUPPLIER_TAGS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  addSupplierTag(context, supplierTag) {
    return new Promise((resolve, reject) => {
      axios
        .post('/v1/supplier_tags', {
          supplier_tag: supplierTag,
        })
        .then(response => {
          context.dispatch('fetchSupplierTags')
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  fetchSupplierTag(context, { supplierTagId }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/v1/supplier_tags/${supplierTagId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  editSupplierTag(context, supplierTag) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/v1/supplier_tags/${supplierTag.id}`, {
          supplier_tag: supplierTag,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  deactivateSupplierTag(context, supplierTag) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/v1/supplier_tags/${supplierTag.id}`, {
          supplier_tag: { ...supplierTag, active_status: !supplierTag.active_status },
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
